// ─── CONFIG ───────────────────────────────────────────────────────────────────
// The backend URL lives in brand.js (API_URL). Change it there, not here.
// Still exported as BASE_URL so existing imports from "./api" keep working.
import { BRAND } from "./brand";
export const BASE_URL = BRAND.apiUrl;

// ─── API CLIENT ───────────────────────────────────────────────────────────────
export const api = {
  get: async (path) => {
    const res = await fetch(`${BASE_URL}${path}`);
    if (!res.ok) { const msg = await res.text(); throw new Error(msg || res.statusText); }
    return res.json();
  },
  post: async (path, body) => {
    const res = await fetch(`${BASE_URL}${path}`, {
      method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body),
    });
    if (!res.ok) { const msg = await res.text(); throw new Error(msg || res.statusText); }
    return res.json();
  },
  patch: async (path, body) => {
    const res = await fetch(`${BASE_URL}${path}`, {
      method: "PATCH", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body),
    });
    if (!res.ok) { const msg = await res.text(); throw new Error(msg || res.statusText); }
    return res.json();
  },
  delete: async (path) => {
    const res = await fetch(`${BASE_URL}${path}`, { method: "DELETE" });
    if (!res.ok) { const msg = await res.text(); throw new Error(msg || res.statusText); }
    return res.json();
  },
  // Upload one or more files to the shared /upload-files endpoint.
  // Returns an array of Cloudinary URLs (the API's `data` field).
  upload: async (files) => {
    const list = Array.isArray(files) ? files : [files];
    const form = new FormData();
    list.forEach((f) => form.append("files[]", f));
    // NB: do NOT set Content-Type — the browser adds the multipart boundary.
    const res = await fetch(`${BASE_URL}/upload-files`, { method: "POST", body: form });
    if (!res.ok) { const msg = await res.text(); throw new Error(msg || res.statusText); }
    const json = await res.json();
    if (!json?.success || !Array.isArray(json.data)) {
      throw new Error(json?.message || "Upload failed");
    }
    return json.data; // string[] of URLs
  },
};